"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MetaHierarchy = void 0;
/**
 * Restricts values of the user-action event metaHierarchy items.
 */
let MetaHierarchy = exports.MetaHierarchy = /*#__PURE__*/function (MetaHierarchy) {
  // Main delivery selection items
  /** Top level hierarchy item marking actions in Checkout Delivery Step. */
  MetaHierarchy["DeliverySelection"] = "Delivery selection";
  /** Empty selection so far & Delivery Options dialog was shown via clicking on find delivery box / link. */
  MetaHierarchy["FirstSelection"] = "First selection";
  /** There was a selected delivery option & Delivery Options dialog was shown by clicking on edit link. */
  MetaHierarchy["EditSelection"] = "Edit selection";
  /** User left selected previous delivery & just continued by clicking the next button. */
  MetaHierarchy["PreviousSelection"] = "Previous selection";
  // Actions done in the Delivery Options dialog (1st dialog level)
  // TO-DO: This value could be probably skipped.
  /** This is being filled as next level item when there are no addresses yet & no delivery options history. */
  MetaHierarchy["New"] = "New";
  /** Actions done in available addresses tab in Delivery Options dialog. */
  MetaHierarchy["Addresses"] = "Addresses";
  /** Actions done in history tab in Delivery Options dialog. */
  MetaHierarchy["History"] = "History";
  /**
   * User changed filter for results displayed in Delivery Options dialog, History or Addresses tabs,
   * or at the top of Find Pickup Points dialog for results in list or map tabs.
   */
  MetaHierarchy["UseFilter"] = "Use filter";
  /*
  Actions for manipulating address data. Here we measure just the original intention
  to change the data, not the final result (user could cancel it for example).
  Updating of the address data itself (new address & edit address actions) is being
  done in the Address Form dialog (2nd level dialog, component in scope of Acquisition
  team - contact them in case of more detailed analytics needs while editing the address data).
   Delete address action is done completely in Delivery Options dialog / Checkout Delivery component
  scope and doesn't need to display the Address Form dialog.
  */
  /** New address button was clicked. */
  MetaHierarchy["NewAddress"] = "New address";
  /** Edit address button was clicked. */
  MetaHierarchy["EditAddress"] = "Edit address";
  /** Delete address button was clicked. */
  MetaHierarchy["DeleteAddress"] = "Delete address";
  // Actions done in the Find Pickup Points dialog (2nd dialog level)
  /** Actions done in Find Pickup Points dialog. */
  MetaHierarchy["PickUpPoint"] = "Pick up point";
  /** Send event when Find Pickup Points dialog was shown. */
  MetaHierarchy["PickUpPointOpen"] = "Pick up point open";
  /** Actions done in list search tab in Find Pickup Points dialog. */
  MetaHierarchy["ListSearch"] = "List search";
  /** Actions done in map search tab in Find Pickup Points dialog (if available). */
  MetaHierarchy["MapSearch"] = "Map search";
  /**
   * The user typed some text into focused search field & submitted it via hitting enter, clicking the search button
   * in the search field, or via clicking the submit button on mobile keyboard.
   */
  MetaHierarchy["BasicSearch"] = "Basic search";
  /** Instant result was selected from the shown search dropdown. */
  MetaHierarchy["SelectInstantResult"] = "Select instant result";
  // TO-DO: This could be called 'Pre-select result'.
  /**
   * User pre-selected an item in nearby results in list tab or per-selected a pickup point in map tab,
   * supposedly nearby her / his current or searched coordinates.
   * This shows / highlights the detailed info box with confirm button, where the final result selection is made.
   * According to the other values in the metaHierarchy, we know whether the action was made in list tab or in map.
   */
  MetaHierarchy["SelectNearby"] = "Select nearby";
  /**
   * User selected the final result after basic search in list, or clicked confirm button on preselected search result
   * in nearby results in list tab, or in map tab.
   */
  MetaHierarchy["SelectResult"] = "Select result";
  // Home delivery, courier selection items
  /** Information about courier selection for home delivery. */
  MetaHierarchy["HomeDeliveryCourierSelection"] = "Home delivery Courier selection";
  /** Previous home delivery courier selection was left intact when leaving delivery step. */
  MetaHierarchy["PreviouslyUsedCourier"] = "Previously used courier";
  /** New courier was selected for home delivery. */
  MetaHierarchy["NewCourierSelection"] = "New courier selection";
  // Shipping offer actions
  /** Information about shipping offer utilization by the user. */
  MetaHierarchy["ShippingOfferSelection"] = "Shipping offer selection";
  /** The shipping offer dialog was automatically displayed when trying to go to the next checkout step. */
  MetaHierarchy["AutomaticallyTriggered"] = "Automatically triggered";
  /** User selected the shipping offer directly via delivery card's shipping offer button. */
  MetaHierarchy["TriggeredFromDeliveryCard"] = "Triggered from the delivery card";
  /** Offer is available but selection was skipped by the user. */
  MetaHierarchy["SkippedByUser"] = "Skipped by the user";
  return MetaHierarchy;
}({});